/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TimExecution } from './TimExecution';
import {
    TimExecutionFromJSON,
    TimExecutionFromJSONTyped,
    TimExecutionToJSON,
    TimExecutionToJSONTyped,
} from './TimExecution';

/**
 * 
 * @export
 * @interface GetTimExecution200Response
 */
export interface GetTimExecution200Response {
    /**
     * 
     */
    data?: TimExecution;
}

/**
 * Check if a given object implements the GetTimExecution200Response interface.
 */
export function instanceOfGetTimExecution200Response(value: object): value is GetTimExecution200Response {
    return true;
}

export function GetTimExecution200ResponseFromJSON(json: any): GetTimExecution200Response {
    return GetTimExecution200ResponseFromJSONTyped(json, false);
}

export function GetTimExecution200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetTimExecution200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : TimExecutionFromJSON(json['data']),
    };
}

export function GetTimExecution200ResponseToJSON(json: any): GetTimExecution200Response {
    return GetTimExecution200ResponseToJSONTyped(json, false);
}

export function GetTimExecution200ResponseToJSONTyped(value?: GetTimExecution200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': TimExecutionToJSON(value['data']),
    };
}

